import moment from 'moment';
import { OnSchedHelpers } from '.';
import { OnSchedTemplates } from '../../OnSchedTemplates';


export const HeaderToolbar = {
  left: 'refresh today',
  center: 'prev,title,next',
  right: 'resourceTimeGridDay,timeGridWeek,dayGridMonth'
}

export const CalendarEventClassNames = e => {
  let classNames = [];
  if (e.event.extendedProps.object === 'unavailableTime') {
    switch (e.event.extendedProps.reasonCode) {
      case CalendarReasonCodes.GCU.code:
        classNames = ['external-calendar-event', 'google-calendar-event'];
        break;
      case CalendarReasonCodes.OCU.code:
        classNames = ['external-calendar-event', 'outlook-calendar-event'];
        break;
      case CalendarReasonCodes.RAB.code:
        classNames = ['onsched-calendar-block'];
        break;
      default:
        classNames = ['external-calendar-event'];
    }
  }
  else if (e.event.extendedProps.object === 'appointment') {
    const slotDuration = e.view.getCurrentData().options.slotDuration.milliseconds / 60000;
    if (e.event.extendedProps.duration === slotDuration) {
      classNames = ['oneline-calendar-event'];
    }
  }
  return classNames
}

export const CustomEventContent = (element, e) => {
  let icon = '';
  let externalCalendar = false;
  const isDayView = e.view.type === OnSchedHelpers.CalendarViews.day;
  const initials = e.event.extendedProps.resourceName.split(' ')
    .map(n => n.charAt(0).toUpperCase())
    .join('')
    .slice(0, 2);

  if (e.event.extendedProps.objectName === 'unavailableTime') {
    if (e.event.extendedProps.reasonCode === 'GCU') {
      icon = '<i class="fab fa-google"></i>';
      externalCalendar = true;
    }
    else if (e.event.extendedProps.reasonCode === 'OCU') {
      icon = '<i class="fab fa-microsoft"></i>';
      externalCalendar = true;
    }
    // else if (e.event.extendedProps.reasonCode === 'RAB') {
    //   icon = '<i class="fas fa-ban"></i>';
    // }
  }

  let data = { html: '' };
  const eventTitle = externalCalendar ? 'Unavailable' : e.event.title;

  // const formattedStart = e.event._context.options.timeZone === 'local' ? moment(e.event.start).format('h:mma') : moment(e.event.start).tz('UTC').format('h:mma')

  if (element.params.eventTitle?.length) {
    if (element.params.eventTitle.html?.length) {
      data = { html: eventTitle };
    }
    else {
      data = { html: `<div data-appointmentid="${e.event.extendedProps.id}" title="${eventTitle}">${icon}${isDayView ? '' : `<span class="onsched-calendar-event-initials">${initials}</span>`}<span class="onsched-event-detail">${eventTitle}</span></div>` };
    }
  }
  else {
    data = { html: `<div data-appointmentid="${e.event.extendedProps.id}" title="${eventTitle}">${icon}${isDayView ? '' : `<span class="onsched-calendar-event-initials">${initials}</span>`}<span class="onsched-event-title">${eventTitle}</span></div>` };
  };

  return data;
}

export const ServiceSelectedInfo = (initialServiceId, services) => {
  // const elServicesSelected = document.getElementById('service-selected-info');
  // const elServiceSelect = document.getElementById('onsched-calendar-service-select');
  // const initialService = services.filter(s => s.id === initialServiceId)[0];

  // // Init current selected info on element
  // elServicesSelected.innerHTML = OnSchedTemplates.ServiceSelectedInfo(initialService);

  // // Init onchange
  // elServiceSelect.onchange = e => {
  //   const newService = services.filter(s => s.id === e.target.value)[0];

  //   elServicesSelected.innerHTML = OnSchedTemplates.ServiceSelectedInfo(newService);
  // }
}

export const CalendarLoading = (element, loading) => {
  const loadingClassName = 'calendar-loading';
  const el = document.getElementById(element.id);

  if (el.classList.contains(loadingClassName)) {
    if (!loading) {
      el.classList.remove(loadingClassName);
    }
  }
  else {
    if (loading) {
      el.classList.add(loadingClassName);
    }
  }
}

export const CalendarViews = {
  day: 'resourceTimeGridDay',
  week: 'timeGridWeek',
  month: 'dayGridMonth'
}

export const CalendarReasonCodes = {
  GCU: {
    code: 'GCU',
    calendar: 'Google',
    reason: 'Google Synched Event'
  },
  OCU: {
    code: 'OCU',
    calendar: 'Outlook',
    reason: 'Outlook Synched Event'
  },
  RAB: {
    code: 'RAB',
    calendar: 'OnSched',
    reason: 'Resource Block'
  },
  BK: {
    code: 'BK',
    calendar: 'OnSched',
    reason: 'OnSched Booked Appointment'
  },
  CN: {
    code: 'CN',
    calendar: 'OnSched',
    reason: 'OnSched Cancelled Appointment'
  },
  RS: {
    code: 'RS',
    calendar: 'OnSched',
    reason: 'OnSched Reservation'
  },
  RE: {
    code: 'RE',
    calendar: 'OnSched',
    reason: 'Rescheduled OnSched Appointment'
  },
  IN: {
    code: 'IN',
    calendar: 'OnSched',
    reason: 'Initial OnSched Appointment'
  },
}

export const GetCalendarPostion = (e) => {
  const elTimesContainer = document.querySelector('.fc-scroller-liquid-absolute');
  const elTimesContainerRects = elTimesContainer?.getBoundingClientRect();
  const elMonthContainerRects = document.querySelector('.fc-dayGridMonth-view')?.getBoundingClientRect();

  let positionX = 0;
  let positionY = 0

  if (e.el) {
    if (e.view.type === CalendarViews.month) {
      // Month View
      if (e.el.closest('.fc-daygrid-day')) {
        // Appointment selected from day cell
        if ((e.el.closest('.fc-daygrid-day').offsetLeft + e.jsEvent.clientX) < ((elMonthContainerRects.width / 3))) {
          positionX = 0
        }
        else if ((e.el.closest('.fc-daygrid-day').offsetLeft + e.jsEvent.clientX) < ((elMonthContainerRects.width / 3) * 2)) {
          positionX = 1
        }
        else {
          positionX = 2
        }

        if ((e.el.closest('.fc-daygrid-day').offsetTop + (e.el.closest('.fc-daygrid-day').clientHeight / 2) + e.jsEvent.clientY) - window.scrollY < (document.querySelector('.fc-dayGridMonth-view').clientHeight / 3)) {
          positionY = 0
        }
        else if (((e.el.closest('.fc-daygrid-day').offsetTop + (e.el.closest('.fc-daygrid-day').clientHeight / 2) + e.jsEvent.clientY) - window.scrollY) < ((document.querySelector('.fc-dayGridMonth-view').clientHeight / 3) * 2)) {
          positionY = 1
        }
        else {
          positionY = 2
        }
      }
      else if (e.el.closest('.fc-popover')) {
        // Appointment selected from popover
        if (e.el.closest('.fc-popover').offsetLeft < (elMonthContainerRects.width / 3)) {
          positionX = 0;
        }
        else if (e.el.closest('.fc-popover').offsetLeft < (elMonthContainerRects.width / 3) * 2) {
          positionX = 1;
        }
        else {
          positionX = 2;
        }

        if (e.el.closest('.fc-popover').offsetTop < (document.querySelector('.fc-dayGridMonth-view').clientHeight / 3)) {
          positionY = 0;
        }
        else if (e.el.closest('.fc-popover').offsetTop < ((document.querySelector('.fc-dayGridMonth-view').clientHeight / 3) * 2)) {
          positionY = 1;
        }
        else {
          positionY = 2;
        }
      }
      else {
        // Unknown
      }
    }
    else {
      // Day or Week View
      if ((e.view.type === CalendarViews.week ? e.el.closest('.fc-timegrid-col').offsetLeft : e.jsEvent.clientX) < ((elTimesContainerRects.width / 3))) {
        positionX = 0
      }
      else if ((e.view.type === CalendarViews.week ? e.el.closest('.fc-timegrid-col').offsetLeft : e.jsEvent.clientX) < ((elTimesContainerRects.width / 3) * 2)) {
        positionX = 1
      }
      else {
        positionX = 2
      }

      if (e.jsEvent.clientY + e.el.closest('.fc-timegrid-event-harness').offsetTop - elTimesContainer.scrollTop - window.scrollY < (elTimesContainerRects.height / 3)) {
        positionY = 0
      }
      else if ((e.jsEvent.clientY + e.el.closest('.fc-timegrid-event-harness').offsetTop - elTimesContainer.scrollTop - window.scrollY) < ((elTimesContainerRects.height / 3) * 2)) {
        positionY = 1
      }
      else {
        positionY = 2
      }
    }
  }
  else {
    if (e.view.type === CalendarViews.month) {
      // Month View
      if ((e.dayEl.offsetLeft + (e.jsEvent.type.includes('touch') ? e.jsEvent.changedTouches[e.jsEvent.changedTouches.length - 1].clientX : e.jsEvent.clientX)) < ((elMonthContainerRects.width / 3))) {
        positionX = 0
      }
      else if ((e.dayEl.offsetLeft + (e.jsEvent.type.includes('touch') ? e.jsEvent.changedTouches[e.jsEvent.changedTouches.length - 1].clientX : e.jsEvent.clientX)) < ((elMonthContainerRects.width / 3) * 2)) {
        positionX = 1
      }
      else {
        positionX = 2
      }

      if ((e.dayEl.offsetTop + (e.dayEl.clientHeight / 2) + (e.jsEvent.type.includes('touch') ? e.jsEvent.changedTouches[e.jsEvent.changedTouches.length - 1].clientY : e.jsEvent.clientY)) - window.scrollY < (document.querySelector('.fc-dayGridMonth-view').clientHeight / 3)) {
        positionY = 0
      }
      else if (((e.dayEl.offsetTop + (e.dayEl.clientHeight / 2) + (e.jsEvent.type.includes('touch') ? e.jsEvent.changedTouches[e.jsEvent.changedTouches.length - 1].clientY : e.jsEvent.clientY)) - window.scrollY) < ((document.querySelector('.fc-dayGridMonth-view').clientHeight / 3) * 2)) {
        positionY = 1
      }
      else {
        positionY = 2
      }
    }
    else {
      // Day or Week View
      if ((e.jsEvent.type.includes('touch') ? e.jsEvent.changedTouches[e.jsEvent.changedTouches.length - 1].clientX : e.jsEvent.clientX) < ((elTimesContainerRects.width / 3))) {
        positionX = 0
      }
      else if ((e.jsEvent.type.includes('touch') ? e.jsEvent.changedTouches[e.jsEvent.changedTouches.length - 1].clientX : e.jsEvent.clientX) < ((elTimesContainerRects.width / 3) * 2)) {
        positionX = 1
      }
      else {
        positionX = 2
      }

      if ((e.jsEvent.type.includes('touch') ? e.jsEvent.changedTouches[e.jsEvent.changedTouches.length - 1].clientY : e.jsEvent.clientY) - window.scrollY < (elTimesContainerRects.height / 3)) {
        positionY = 0
      }
      else if (((e.jsEvent.type.includes('touch') ? e.jsEvent.changedTouches[e.jsEvent.changedTouches.length - 1].clientY : e.jsEvent.clientY) - window.scrollY) < ((elTimesContainerRects.height / 3) * 2)) {
        positionY = 1
      }
      else {
        positionY = 2
      }
    }
  }

  return { positionX, positionY }
}

export const GetMultiResourceData = (oldAppointmentResources, apptDetails) => {
  const oldResourceIdsArr = oldAppointmentResources.map(r => r.resourceId);
  const oldSelectedResourceId = apptDetails.oldEvent._def.resourceIds[0];
  const newSelectedResourceId = apptDetails.event._def.resourceIds[0];
  const index = oldResourceIdsArr.indexOf(oldSelectedResourceId);

  let multiResourceData = {};
  multiResourceData.oldEventResourceIds = oldAppointmentResources.map(r => r.resourceId);

  let newResourceIdsArr = oldResourceIdsArr;

  if (index !== -1) {
    newResourceIdsArr[index] = newSelectedResourceId;
  }

  multiResourceData.newEventResourceIds = newResourceIdsArr;

  const resourceNamesArr = oldAppointmentResources?.map(r => r.resourceName);
  let multiResource = false;
  let resourceNames = '<span>' + resourceNamesArr.join('</span>, <span>') + '</span>'

  if (oldAppointmentResources) {
    if (oldAppointmentResources.length > 1) {
      const lastResource = resourceNamesArr.pop();

      multiResource = true;
      resourceNames = '<span>' + resourceNamesArr.join('</span>, <span>') + '</span>' + ' and <span>' + lastResource + '</span>';
    }
  }

  multiResourceData.multiResource = multiResource;
  multiResourceData.resourceNamesAffectedHTML = resourceNames;
  multiResourceData.resourceChanged = oldSelectedResourceId !== newSelectedResourceId;
  multiResourceData.originalResourceId = oldSelectedResourceId;
  multiResourceData.updatedResourceId = newSelectedResourceId;

  return multiResourceData;
}

export const GetResourceBusinessHours = (element, resource) => {
  if (!element.options.businessHours) {
    return false
  }

  const FormatTime = (time) => {
    if (time == null) {
      return "";
    }

    const hour = Math.floor(time / 100);
    const min = time % 100;

    let minsString = min.toString();
    minsString = minsString.length < 2 ? minsString + "0" : minsString;

    const fmtTime = hour + ":" + minsString;

    return fmtTime;
  }

  const businessHours = [
    {
      startTime: FormatTime(resource.availability.mon.startTime),
      endTime: FormatTime(resource.availability.mon.endTime),
      daysOfWeek: [1]
    },
    {
      startTime: FormatTime(resource.availability.tue.startTime),
      endTime: FormatTime(resource.availability.tue.endTime),
      daysOfWeek: [2]
    },
    {
      startTime: FormatTime(resource.availability.wed.startTime),
      endTime: FormatTime(resource.availability.wed.endTime),
      daysOfWeek: [3]
    },
    {
      startTime: FormatTime(resource.availability.thu.startTime),
      endTime: FormatTime(resource.availability.thu.endTime),
      daysOfWeek: [4]
    },
    {
      startTime: FormatTime(resource.availability.fri.startTime),
      endTime: FormatTime(resource.availability.fri.endTime),
      daysOfWeek: [5]
    },
    {
      startTime: FormatTime(resource.availability.sat.startTime),
      endTime: FormatTime(resource.availability.sat.endTime),
      daysOfWeek: [6]
    },
    {
      startTime: FormatTime(resource.availability.sun.startTime),
      endTime: FormatTime(resource.availability.sun.endTime),
      daysOfWeek: [7]
    },
  ];

  return businessHours
}

export const GetAmalgamatedResourceBusinessHours = (element, resources) => {
  if (!element.options.businessHours) {
    return false
  }

  const FormatTime = (time) => {
    if (time == null) {
      return "";
    }

    const hour = Math.floor(time / 100);
    const min = time % 100;

    let minsString = min.toString();
    minsString = minsString.length < 2 ? minsString + "0" : minsString;

    const fmtTime = hour + ":" + minsString;

    return fmtTime;
  }

  const getRealBusinessHours = day => {
    let lowestStartTime = 0;
    let highestEndTime = 2400;

    if (resources.length) {
      lowestStartTime = resources.map(r => r.availability[day]).reduce((prev, curr) => {
        if (prev.startTime < curr.startTime) {
          if (prev.startTime === 0 && prev.endTime === 0) {
            return curr;
          }
          else {
            return prev;
          }
        }
        else {
          return curr
        }
      });

      highestEndTime = resources.map(r => r.availability[day]).reduce((prev, curr) => {
        // return prev.endTime > curr.endTime ? prev : curr
        if (prev.endTime > curr.endTime) {
          if (prev.startTime === 0 && prev.endTime === 0) {
            return curr;
          }
          else {
            return prev;
          }
        }
        else {
          return curr
        }
      });
    }

    return { startTime: lowestStartTime.startTime, endTime: highestEndTime.endTime }
  }

  let businessHours = [
    {
      startTime: FormatTime(getRealBusinessHours('mon').startTime),
      endTime: FormatTime(getRealBusinessHours('mon').endTime),
      daysOfWeek: [1]
    },
    {
      startTime: FormatTime(getRealBusinessHours('tue').startTime),
      endTime: FormatTime(getRealBusinessHours('tue').endTime),
      daysOfWeek: [2]
    },
    {
      startTime: FormatTime(getRealBusinessHours('wed').startTime),
      endTime: FormatTime(getRealBusinessHours('wed').endTime),
      daysOfWeek: [3]
    },
    {
      startTime: FormatTime(getRealBusinessHours('thu').startTime),
      endTime: FormatTime(getRealBusinessHours('thu').endTime),
      daysOfWeek: [4]
    },
    {
      startTime: FormatTime(getRealBusinessHours('fri').startTime),
      endTime: FormatTime(getRealBusinessHours('fri').endTime),
      daysOfWeek: [5]
    },
    {
      startTime: FormatTime(getRealBusinessHours('sat').startTime),
      endTime: FormatTime(getRealBusinessHours('sat').endTime),
      daysOfWeek: [6]
    },
    {
      startTime: FormatTime(getRealBusinessHours('sun').startTime),
      endTime: FormatTime(getRealBusinessHours('sun').endTime),
      daysOfWeek: [7]
    },
  ];

  return businessHours;
}
